import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { PERSONAL_DATA_MENU_ID } from '@headless-workspace/config';
import { useUIContext } from '@headless-workspace/core-ui';
import { GlowButton, GlowModal, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { HTMLString } from '../../../../server';
import { InnerHTML } from '../../innerHTML';

type PersonalDataMenuProps = PropsWithLocale & {
    modalTitle: string;
    description: HTMLString;
    offerLegalMention?: HTMLString;
    isNewsletterBoostEnabled: boolean;
};

export const PersonalDataMenu: Component<PersonalDataMenuProps> = ({
    modalTitle,
    description,
    offerLegalMention,
    isNewsletterBoostEnabled,
}) => {
    const {
        menuModal: { close: closeMenu },
    } = useUIContext();

    const t = useTranslations('Discover.Home.newsletter.menu');

    const onClose = useCallback(() => {
        closeMenu(PERSONAL_DATA_MENU_ID);
    }, [closeMenu]);

    return (
        <GlowModal.Container title={modalTitle} onClick={onClose}>
            <GlowModal.Content>
                <InnerHTML
                    className={'newsletter-banner-description text-bodySmall font-brand'}
                    rawHtml={description}
                />
                {offerLegalMention && isNewsletterBoostEnabled && (
                    <InnerHTML className={'newsletter-banner text-bodySmall font-brand'} rawHtml={offerLegalMention} />
                )}
            </GlowModal.Content>
            <GlowModal.Footer>
                <GlowButton onClick={onClose} label={t('action.confirm')} variant={'secondary'} width={'full'} />
            </GlowModal.Footer>
        </GlowModal.Container>
    );
};
